let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3PImb")).then(() => parcelRequire('037i3'));